// Product tax treatment (Oct 2026) — which order lines carried tax, read
// from the order's OWN per-line snapshot (`tax_breakdown`, written by the
// backend at placement). Never derived from a product's current settings,
// so an old order keeps showing what it was actually billed.
//
// A line is taxable unless it is tax exempt (Product Owner, Oct 2026): a
// custom-rate line is taxable, and so is a line at an explicit 0% rate —
// taxable at zero, which is not the same as exempt. Mirrors
// `backend/services/receipt_tax_groups.py::line_is_taxable`.

export const TAXABLE_MARK = "(T)";

function isTaxable(tb) {
  return !tb.tax_exempt;
}

/** { item_id: true|false } for every line the order recorded. */
export function lineTaxableMap(order) {
  const out = {};
  for (const tb of (order && order.tax_breakdown) || []) {
    if (tb && tb.item_id) out[tb.item_id] = isTaxable(tb);
  }
  return out;
}

/** `name` with " (T)" appended for a taxable line only. */
export function taxMarkedName(name, taxable) {
  return taxable === true ? `${name} ${TAXABLE_MARK}` : name;
}
